import React from 'react';
import PropTypes from 'prop-types';
import csrfToken from './csrf';
import style from './IdCardPrinterBoard.module.sass';

// A real HTML form (not a JS fetch), same as the button_to it replaces: it still
// works with no JS beyond what already rendered the chip, and rails-ujs isn't
// needed since the confirm is a plain onClick, not data-confirm.
const RemoveForm = ({ removeUrl, disabled }) => (
  <form action={removeUrl} method="post" className={style.removeForm}>
    <input type="hidden" name="_method" value="delete" />
    <input type="hidden" name="authenticity_token" value={csrfToken()} />
    <button
      type="submit"
      className="btn btn-link btn-sm"
      disabled={disabled}
      onClick={(event) => {
        // eslint-disable-next-line no-alert
        if (!window.confirm('Remove this printer?')) event.preventDefault();
      }}
    >
      Remove
    </button>
  </form>
);

RemoveForm.propTypes = {
  removeUrl: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

const PrinterChip = ({
  printer, disabled, onUnpair, onRetire,
}) => (
  <div className={style.printerChip}>
    <div className={style.printerChipHeadline}>
      {printer.serial_number && <span>{`Serial # ${printer.serial_number}`}</span>}
      {printer.printer_letter && <span>{`Printer ${printer.printer_letter}`}</span>}
    </div>
    {printer.model && <div className={style.printerChipModel}>{printer.model}</div>}

    {printer.notes && <div className={style.cardNotes}>{printer.notes}</div>}
    {printer.troubleshooting_notes && (
      <div className={style.cardNotes}>
        <strong>Troubleshooting:</strong>
        {` ${printer.troubleshooting_notes}`}
      </div>
    )}

    <div className={style.cardActions}>
      <a href={printer.edit_url}>Edit</a>
      {onUnpair && (
        <button
          type="button"
          className="btn btn-link btn-sm"
          disabled={disabled}
          onClick={() => {
            // eslint-disable-next-line no-alert
            if (window.confirm('Send this printer back to Inventory?')) onUnpair(printer);
          }}
        >
          Unpair
        </button>
      )}
      {onRetire && (
        <button
          type="button"
          className="btn btn-link btn-sm"
          disabled={disabled}
          onClick={() => {
            const message = 'Mark this printer out of commission? '
              + 'It will be unpaired (if paired) and moved to the For Parts list.';
            // eslint-disable-next-line no-alert
            if (window.confirm(message)) onRetire(printer);
          }}
        >
          Out of Commission
        </button>
      )}
      <RemoveForm removeUrl={printer.remove_url} disabled={disabled} />
    </div>
  </div>
);

PrinterChip.propTypes = {
  printer: PropTypes.shape({
    serial_number: PropTypes.string,
    printer_letter: PropTypes.string,
    model: PropTypes.string,
    notes: PropTypes.string,
    troubleshooting_notes: PropTypes.string,
    edit_url: PropTypes.string.isRequired,
    remove_url: PropTypes.string.isRequired,
  }).isRequired,
  disabled: PropTypes.bool.isRequired,
  onUnpair: PropTypes.func,
  onRetire: PropTypes.func,
};

PrinterChip.defaultProps = {
  onUnpair: null,
  onRetire: null,
};

export default PrinterChip;
